
import { createSlice, EntityId } from '@reduxjs/toolkit'

import { widgetWindowsAdapter } from './widgetWindowsAdapter'

type AdditionalInitialStateType = {
  isLayoutLock: boolean,
  activeWidgetWindowId: null | EntityId
}

export const initialWidgetWindowState = widgetWindowsAdapter.getInitialState<AdditionalInitialStateType>({
  isLayoutLock: false,
  activeWidgetWindowId: null,
})

// TODO: ensure that the widgetWindowsSlice is synced with the local storage
export const widgetWindowsSlice = createSlice({
  name: 'widgetWindows',
  initialState: initialWidgetWindowState,
  reducers: {
    upsertOneWidgetWindow: widgetWindowsAdapter.upsertOne,
    setWidgetWindowInactive: (state, action) => {
      const window = state.entities[action.payload]

      if (window) {
        window.isActive = false
      }
    },
    removeOneWidgetWindow: widgetWindowsAdapter.removeOne,
    replaceAllWidgetWindows: widgetWindowsAdapter.setAll,
    toggleLayoutLock: (state) => {
      state.isLayoutLock = !state.isLayoutLock
    },
    updateActiveWidgetWindowId: (state, action) => {
      state.activeWidgetWindowId = action.payload
    },
    updateWidgetWindow: widgetWindowsAdapter.updateOne,
  },
})

export const {
  toggleLayoutLock,
  upsertOneWidgetWindow,
  setWidgetWindowInactive,
  removeOneWidgetWindow,
  updateActiveWidgetWindowId,
  replaceAllWidgetWindows,
  updateWidgetWindow,
} = widgetWindowsSlice.actions
